import type { ISystemMessageTemplate } from "../../types/systemMessages";
import { SystemMessageType } from "../../types/systemMessages";

export const SYSTEM_MESSAGE_TEMPLATE: Record<SystemMessageType, ISystemMessageTemplate> = {
    [SystemMessageType.ApplicationStateChange]: {
        id: "application-state-change",
        type: SystemMessageType.ApplicationStateChange,
        template: "application state change",
        withPayload: true,
        resetMessages: false,
    },
    [SystemMessageType.NewFilterSet]: {
        id: "new-filter-set",
        type: SystemMessageType.NewFilterSet,
        template: "generate suggestions for new filter set",
        withPayload: true,
        resetMessages: true,
    },
    [SystemMessageType.ExistingFilterSet]: {
        id: "existing-filter-set",
        type: SystemMessageType.ExistingFilterSet,
        template: "generate contextual suggestions for existing filter set",
        withPayload: true,
        resetMessages: true,
    },
    [SystemMessageType.RegenerateSuggestions]: {
        id: "regenerate-suggestions",
        type: SystemMessageType.RegenerateSuggestions,
        template: "regenerate suggestions",
        withPayload: true,
        resetMessages: true,
    },
};
